/**
 * Get `All ${selectedCustomerLabel} Charts` chart name
 */
export const getAllChartName = (selectedCustomerLabel: string): string =>
  `All ${selectedCustomerLabel} Charts`;
